import cancelIcon from '@src/main/assets/icons/cross-red.svg';
import { Button } from 'primereact/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CancelButton.module.scss';

interface CancelButtonProps {
  onClick: () => void;
}

export const CancelButton: FC<CancelButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Button
      label={t('common.cancel')}
      icon={<img src={cancelIcon} alt="plus" width="12" />}
      onClick={onClick}
      className={`${styles.button}`}
    />
  );
};
